import { Button } from '@progress/kendo-react-buttons'
import { Grid, GridColumn } from '@progress/kendo-react-grid'
import classnames from 'classnames'
import * as React from 'react'
import { connect } from 'react-redux'
import { Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap'
import * as Redux from 'redux'
import * as App from '../../app/types'
import { FlashMessage } from '../../components/flash-message'
import * as Form from '../../components/form'
import * as Link from '../../components/link'
import { Loading } from '../../components/loading'
import * as RasaModal from '../../components/modal'
import * as RasaInput from '../../components/rasa-input'
import * as Request from '../../request'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Render from './render'
import './styles.css'
import * as Types from './types'
import * as Utils from './utils'

interface HeaderDispatchProps {
  toggleAddSystemMenu: Types.ViewAction
  addSytem: Types.ViewAction
}

const IntegrationsHeader = ({ integrations, toggleAddSystemMenu, addSystem}: any) =>
<div>
  <FlashMessage />
  <Row className="margin-auto">
    <Col sm="12" md="10" className="text-left page-header--padding">
      <div className="page-header">
        <span className="title">Integrations</span>
        {integrations.data.availableSystems ?
        <span>
          <div className="add-info-menu" onClick={toggleAddSystemMenu}
              onMouseLeave={() => integrations.view.addMenu ? toggleAddSystemMenu() : null}>
            <p className="add-text"> ADD </p>
            <i className="fas fa-caret-down icon"/>
              <ul className={classnames('add-info-menu-content', { 'show-add-menu': integrations.view.addMenu })}>
              {integrations.data.availableSystems.map((system: Types.System) => {
                return <li
                          onClick={() => addSystem(system.id, system.name, Constants.SUBSCRIBERS,
                            Utils.getTargetSubscriber(system.name))}
                          key={system.id}>
                          <span >
                            {system.name}
                          </span>
                      </li>
              })}
              </ul>
          </div>
        </span>
        :
        null }
      </div>
    </Col>
  </Row>
<SystemCredentialsModalConnect/>
</div>

export const IntegrationsHeaderConnected = connect(
  ({ integrations }: Types.WrappedState & HeaderDispatchProps) => ({ integrations }),
  {
    addSystem: Actions.onOpen,
    toggleAddSystemMenu: Actions.toggleAddSystemMenu,
  },
)(IntegrationsHeader)

interface AppProps {
  app: App.State
  integrations: Types.FullComponentState
}

interface ModalDispatchProps {
  closeModal: RasaModal.Toggle,
  onSubmit: Redux.ActionCreator<Form.SaveAction<Types.FormFields>>,
  updateField: Redux.ActionCreator<Form.UpdateFieldAction>,
}

type ModalProps = AppProps & ModalDispatchProps

const { FormFieldNames: fieldNames } = Constants

const SystemCredentialsModal = ({ app, integrations, onSubmit, closeModal, updateField }: ModalProps) =>
  <Modal className="modal-lg" isOpen={integrations.modal.isOpen}>
    <form onSubmit={Link.preventDefault()}>
      <ModalHeader toggle={closeModal}>
        {integrations.form.fields.id ?
          `Update credentials for ${integrations.form.fields.system_name}` :
          `Add credentials for ${integrations.form.fields.system_name}`}
      </ModalHeader>
      <ModalBody>
        <FlashMessage />
        <div className="field">
          <RasaInput.RasaInput label={Utils.getKeyLabel(integrations.form.fields.system_name)}
                                placeholder={Utils.getKeyPlaceHolder(integrations.form.fields.system_name)}
                                helpType="system-username"
                                value={integrations.form.fields.key || ''}
                                validation={
                                  RasaInput.validatePresent(integrations.form.fields.key)
                                }
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                  updateField({ name: fieldNames.Key, value: e.target.value })} />
        </div>
        {integrations.form.fields.system_name === Constants.MAILCHIMP &&
        <div className="field">
          <RasaInput.RasaInput label="Audience name"
                                placeholder="Please enter the name of your audience/list "
                                helpType="system-list-name"
                                value={integrations.form.fields.list_name || ''}
                                validation={
                                  RasaInput.validatePresent(integrations.form.fields.list_name)
                                }
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                  updateField({ name: fieldNames.ListName, value: e.target.value })} />
        </div>}
        {integrations.form.fields.system_name === Constants.SALESFORCE &&
        <div className="field">
          <RasaInput.RasaInput label="Password"
                                helpType="system-password"
                                placeholder="Please enter your password"
                                type = "password"
                                value={integrations.form.fields.secret || ''}
                                validation={
                                  RasaInput.validatePresent(integrations.form.fields.secret)
                                }
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                  updateField({ name: fieldNames.Secret, value: e.target.value })} />
        </div>}
        {integrations.form.fields.system_name === Constants.SALESFORCE &&
        <div className="field">
          <RasaInput.RasaInput label="Security Token"
                                helpType="security-token"
                                placeholder="Please enter your security token"
                                value={integrations.form.fields.token || ''}
                                validation={
                                  RasaInput.validatePresent(integrations.form.fields.token)
                                }
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                  updateField({ name: fieldNames.Token, value: e.target.value })} />
        </div>}
      </ModalBody>
      <ModalFooter>
        {integrations.form.isSaving && <Loading size={Loading.Sizes.SMALL} />}
        <Button primary look="outline"
          onClick={Link.preventDefaultThen(() => onSubmit(
            integrations.form.fields.id ? {
              ...Form.modifiedFields(integrations.form),
              id: integrations.form.fields.id,
            } :
              {
                ...Form.modifiedFields(integrations.form),
              },
            ))}
          disabled={!integrations.form.isDirty || integrations.form.isSaving }>
          Save
      </Button>
        <Button look="outline" onClick={closeModal}>Cancel</Button>
      </ModalFooter>
    </form>
  </Modal>

const SystemCredentialsModalConnect = connect(
  ({ app, integrations }: AppProps) => ({ app, integrations }),
  {
    closeModal: Actions.closeModal,
    onSubmit: Actions.FormActions[Form.SAVE],
    updateField: Actions.FormActions[Form.UPDATE],
  },
)(SystemCredentialsModal)

const StatusTable =  ({integrations, dispatch}: any) => {
  return integrations.view.isFetching ?
    <span>
      <Loading size={Loading.Sizes.MEDIUM}/>
    </span>
    :
    <div className="existing-systems-container">
        <Grid data={Request.withDispatch(integrations.data.existingSystems, dispatch)}
              resizable={true}>
          <GridColumn cell={Render.ActiveCell} field="is_active" title="Active" width={50}/>
          <GridColumn field="name" title="System Name" width={200}/>
          <GridColumn cell={Render.LinkMappingsCell} field="id" title="Mappings" width={50}/>
          <GridColumn cell={Render.LinkReportsCell} field="id" title="Reports" width={50}/>
        </Grid>
    </div>
}

const StatusTableConnected = connect(
  ({integrations, app}: Types.WrappedState & App.WrappedState) => ({integrations, app}),
  (dispatch) => ({dispatch}),
)(StatusTable)

const Integrations = () =>
  <div>
    <IntegrationsHeaderConnected/>
    <StatusTableConnected/>
  </div>

export const IntegrationsConnected = connect(
  ({integrations, app}: Types.WrappedState & App.WrappedState) => ({integrations, app}),
  (dispatch) => ({dispatch}),
)(Integrations)



// WEBPACK FOOTER //
// ./src/pages/integrations/component.tsx